import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  activeSubscriptionsLoader = new BehaviorSubject<boolean>(false);
  inactiveSubscriptionsLoader = new BehaviorSubject<boolean>(false);

  get activeLoader$(): Observable<boolean> {
    return this.activeSubscriptionsLoader.asObservable();
  }

  get inactiveLoader$(): Observable<boolean> {
    return this.inactiveSubscriptionsLoader.asObservable();
  }

  setActiveSubscriptionsLoader(value: boolean): void {
    this.activeSubscriptionsLoader.next(value);
  }

  setInactiveSubscriptionsLoader(value: boolean): void {
    this.inactiveSubscriptionsLoader.next(value);
  }
}
